/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BackspaceIcon = /*#__PURE__*/ createSvgIcon(
  'BackspaceIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.728 5.138a2.41 2.41 0 00-1.712-.638H8.351a1.62 1.62 0 00-1.268.619l-.026.034-3.57 3.216L1.735 10l1.754 1.631 3.569 3.216.026.034a1.62 1.62 0 001.268.619h7.665a2.41 2.41 0 002.484-2.282V6.782a2.41 2.41 0 00-.772-1.644zM8.35 4v-.5h7.642A3.41 3.41 0 0119.5 6.746l.001.012V13.254a3.41 3.41 0 01-3.508 3.246H8.348a2.62 2.62 0 01-2.023-.966L2.81 12.366.266 10l2.55-2.371 3.51-3.163A2.62 2.62 0 018.347 3.5l.002.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.688 12.815l-5.04-5.01.704-.71 5.04 5.01-.704.71z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.393 7.805l-5.04 5.01-.706-.71 5.04-5.01.706.71z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default BackspaceIcon;
